'use client';

import { Box } from "@chakra-ui/react";

export default function Container({ children }) {
  return (
    <Box w="100%" maxW="1440px" m="auto" px="4" overflow="hidden">
      { children }
    </Box>
  )
}
